import React, { useEffect, useState } from "react";
import { Navigate, Route, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useLoggedContext } from "./AuthContext";
import { isLogged, removeTokens } from "../Utils/AuthUtils";
import axios from "axios";
import Swal from "sweetalert2";
import { GetBasePath, GetGoBackFlag, SetGoBackFlag } from "../Utils/BaseUtils";

const PrivateRoute = (props: any) => {
  const { auth, setAuth } = useLoggedContext();
  const navigate = useNavigate();
  const location = useLocation().pathname.replace('/', '');
  const basePath = GetBasePath();

  useEffect(() => {
    if (auth !== isLogged()) {
      setAuth(isLogged());
    }
    if (!auth) {
      SetGoBackFlag('true');
    }
    // const urls = process.env.REACT_APP_ALLOWED_URLS?.split(',');
    // window.addEventListener("message", (event) => {
    //   if (urls?.includes(event.origin)) {
      
    //     if (event?.data?.auth) {
    //       localStorage.setItem('Authorization', event.data.auth);
    //       localStorage.setItem('onlybody', event.data.onlybody);
    //       localStorage.setItem('hidetabs', event.data.hidetabs);
    //       setAuth(true);
    //     }
    //     if (navigate) {
    //       navigate(event.data.path);
    //     }
    //     window.parent.postMessage({pageLoaded: true}, '*');
    //   }
    // }, false);
    axios.interceptors.response.use(undefined, error => {
      if (error && error.response?.status === 401) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          },
          didClose: () => {
            removeTokens();
            setAuth(false);
            SetGoBackFlag('true');
            navigate('/login');
            return;
          }
        })

        Toast.fire({
          icon: 'error',
          title: 'Il token non è valido o non esiste, effettua un nuovo login.'
        })
      }
    });
  }, [location])
  return <>{auth ? <Outlet {...props} /> : <Navigate to='/login' />}</>
};

export default PrivateRoute;
